import axios from "axios";

var StateCountyPBP = {
    initializeHeaders: function (headers) {
        axios.defaults.headers.common = headers;
    },
    get: function () {
        return axios.get(Apollo.resolveApiUrl("~/statecountypbp"), {});
    },
};

export default StateCountyPBP;



// WEBPACK FOOTER //
// ./src/models/StateCountyPBP.js